export default __webpack_public_path__ + "static/media/HyattRegencyHotel.49d567cc.jpg";